import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BaseModel } from './base-model.model';
import { Estado } from './estado.model';
import { Amortizacao, HistoricoOperacaoCreditoLivre } from './operacao-credito-livre.model';
import {Generos} from './generos-enum';


export abstract class OperacaoGarantida extends BaseModel {

    /* campos enviados pelo Agente Financeiro */
    public modalidadeFGI: string;
    public cnpjAgenteFinanceiro: string;
    public codigoTipoOperacao: string;
    public dataReferenciaProtocolo: Date;
    public dataEnvio: Date;
    public cnpjClienteFinal: string; // se clienteFinalPessoaFisica for true, entao este campo será um CPF!
    public clienteFinalPessoaFisica: boolean
    public riscoOperacao: string;
    public valorPerdaEsperada: number;
    public dataContratacao: Date;
    public percentualGarantido: number;
    public valorOperacao: number;
    public cnaeClienteFinal: string;
    public cnaeEnquadramento: string;
    public indicadorMicroempreendedorIndividual: string;
    public ideCustoFinanceiroProtocolo: number;

    public receitaBrutaClienteFinal: number;
    public tipoReceitaBruta: string;
    public dataReferenciaReceitaBruta: Date;

    public codigoValidacaoProjeto: string; // aplicavel apenas ao FG ENERGIA

    public detalhe: DetalheOperacaoGarantida;

    public indexadorAtualizacaoGarantia: string;
    public taxaAdicionalAtualizacaoGarantia: number;
    public indicadorPessoaComDeficiencia: string;
    public telefoneBeneficiario: string;
    public numeroAgenciaBeneficiario: number;
    public nomeSocioBeneficiario: string;
    public emailBeneficiario: string;
    public dataNascSocioBeneficiario: Date;
    public generoSocioBeneficiario: string;
    public cpfSocioBeneficiario: string;
    public dataInformeLiquidacao: Date;
    public tipoRecebimento?: boolean;

    }

export class AditivoOperacaoCreditoLivre extends OperacaoGarantida {
    public dataCelebracaoAditivo: Date;
    public dataProtocoloAditivo?: Date;
    public ecgDeveSerSomadoAoValorOperacao: string;
    public valorEcgComplementar: number;
    public valorRedutorEcgComplementar: number;
    public valorSaldoDevedorNaDataDoAditivo: number;
    public quantidadeMesesPrazoAdicional: number;
    public ideCobrancaEcgComplementar: number;
    public aditivo: boolean;
    public historicoAntesAditivo: HistoricoOperacaoCreditoLivre;
}

export class DetalheOperacaoGarantida {

    public nomeAgenteFinanceiro: string;

    public historicos: HistoricoEstadoOperacaoGarantida[];
    public liberacoes: LiberacaoOperacaoGarantida[];
    public notas: NotaOperacaoGarantida[];

    public valorCredito: number;
    public valorGarantido: number;
    public valorEcg: number;
    public valorRedutorEcg: number;
    public fatorK: number;
    public ecgDeveSerSomadoAoValorOperacao: string;
    public numeroTranche: number;
    public dataFimRetificacoesTranche: Date;
    public indicadorAditivoHabilitadoTranche: string;
    public estado: Estado;
    public garantiaAtiva: string;
    public retificada: string;
    public honraProcessada: string;
    public honraImpedeAditivo: string;
    public nomeCnaeClienteFinal: string;
    public nomeCnaeEnquadramento: string;
    public limiteAdicional: string;
    public valorLimiteAdicionalTranche: number;

    public podeSerRetificada: boolean;
    public podeSerAditada: boolean;

    public prazoAmortizacaoEmMeses: number;
    public prazoCarenciaEmMeses: number;
    public prazoEmMeses: number;

    public prazoAmortizacaoContratualEmMeses: number;
    public prazoCarenciaContratualEmMeses: number;
    public prazoContratualEmMeses: number;

    public aditivos: AditivoOperacaoCreditoLivre[];

    public estadoSolicitacaoHonraAtual: Estado;

    public percentualGarantidoASerHonrado: number;
}

export class LiberacaoOperacaoGarantida extends BaseModel {

    public numero: number;
    public data: Date;
    public valor: number;
    public valorEcg: number;
    public valorRedutorEcg: number;
    public estadoDTO: Estado;
    public retificada: boolean;
}

export class HistoricoEstadoOperacaoGarantida extends BaseEntity {

    public dataUltimaAtualizacao: Date;
    public estado: Estado;
    public nomeUsuarioResponsavel: string;
}

export class NotaOperacaoGarantida extends BaseModel {

    public descricao: string;
    public nomeArquivo: string;
    public nomeUsuarioEnvio: string;
    public dataEnvio: Date;
}

export class TipoOperacao {
    public codigo: string;
    public descricao: string;
}

export const TIPOS_OPERACAO = [
  {
  codigo: 'L',
  label: 'L - Crédito Livre'
  },
  {
    codigo: 'R',
    label: 'R - Repasse BNDES'
  }
];

export const TIPO_ESTADO = [
  {
  codigo: '1',
  sigla: 'PROTOC',
  nome:'Protocolada'
  },
  {
  codigo: '2',
  sigla: 'AG-APROV',
  nome:'Aguardando aprovação'
  },
  {
  codigo: '3',
  sigla: 'APROV',
  nome:'Aprovada sob condição pagto. ECG quando aplicável.'
  },
  {
  codigo: '4',
  sigla: 'AG-LQ-COB',
  nome:'Aguardando liquidação da cobrança'
  },
  {
  codigo: '5',
  sigla: 'ATV-C-LB-FUT',
  nome:'Ativa com liberações futuras'
  },
  {
  codigo: '6',
  sigla: 'ATV-S-LB-FUT',
  nome:'Ativa sem liberações futuras'
  },
  {
  codigo: '7',
  sigla: 'RETIF-SUB',
  nome:'Retificação submetida'
  },
  {
  codigo: '8',
  sigla: 'SOG-CANC',
  nome:'Solicitação de outorga cancelada'
  },
  {
  codigo: '9',
  sigla: 'CANC',
  nome:'Garantia cancelada'
  },
  {
  codigo: '10',
  sigla: 'REPROV',
  nome:'Reprovada'
  },
  {
  codigo: '11',
  sigla: 'ATV-S-VINC',
  nome:'Ativa sem prestação vincenda'
  },
  {
  codigo: '12',
  sigla: 'EM-GRAV',
  nome:'Em gravação'
  },
  {
  codigo: '13',
  sigla: 'EM-CANC',
  nome:'Em cancelamento'
  },
  {
  codigo: '14',
  sigla: 'GAR-EXAUR',
  nome:'Garantia exaurida'
  },

];
